var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.localIsOpen,
        width: _vm.width,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": [
          function ($event) {
            _vm.localIsOpen = $event
          },
          _vm.handleUpdateVisible,
        ],
        close: _vm.handleUpdateVisible,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }